import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { SavingsPlanFacade } from '@zero/saving-plans/domain';
import { commonRoutes } from 'constants/web-app-constants';
import { OnboardingContainerComponent } from '../../../components/onboarding-container/onboarding-container.component';

@Component({
  imports: [OnboardingContainerComponent, TranslocoPipe],
  templateUrl: './success.component.html',
})
export class SuccessComponent implements OnInit {
  readonly #facade = inject(SavingsPlanFacade);
  readonly #router = inject(Router);
  public goToOverview = () => this.#router.navigateByUrl(commonRoutes.postlogin.savings_plans);

  ngOnInit(): void {
    this.#facade.clearOnboardingSavingsPlanForm();
  }
}
